



























































































































































import { computed, defineComponent, ref, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import Multiselect from "vue-multiselect";
import { $t } from "@/lib/i18nHelpers";
import { DropdownGroupOptionStructure, DropdownOptionStructure } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIconButton from "@/components/BaseIconButton";
import BaseSpinner from "@/components/BaseSpinner";
import ValidationProvider from "@/components/ValidationProvider";
import "vue-multiselect/dist/vue-multiselect.min.css";

export const defaultProps = {
  label: { type: String as PropType<TranslateResult> },
  hint: { type: String as PropType<TranslateResult> },
  invalidField: { type: Boolean, default: false },
  hideBorder: { type: Boolean, default: false },
  hideErrorMessage: { type: Boolean, default: false },
  fieldClass: {
    type: [String, Object, Array] as PropType<string | Record<string, boolean> | (string | Record<string, boolean>)[]>,
  },
  isAvatarIcon: { type: Boolean, default: false },

  prependIcon: { type: String },
  prependIconSize: { type: String },
  prependIconColor: { type: String },

  rules: { type: [Array, Object, String] as PropType<string[] | Record<string, any> | string>, default: () => [] },
  rulesMessages: { type: Object as PropType<Record<string, string>>, default: () => ({}) },
  validationMode: {
    validator: (value?: string): boolean => {
      return !value || ["aggressive", "passive", "lazy", "eager"].includes(value);
    },
  },
};

export const selectProps = {
  name: { type: String },
  value: { type: [String, Boolean, Number, Object, Array] },
  options: {
    type: Array as () => DropdownGroupOptionStructure[] | DropdownOptionStructure[],
  },
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  isGrouped: { type: Boolean, default: false },
  multiple: { type: Boolean, default: false },
  searchable: { type: Boolean, default: false },
  clearOnSelect: { type: Boolean, default: true },
  closeOnSelect: { type: Boolean, default: true },
  showNoOptions: { type: Boolean, default: true },
  showNoResults: { type: Boolean, default: true },
  max: { type: Number },
  maxHeight: { type: Number, default: 304 },
  visibleOptionsLimit: { type: Number, default: 1000 },
  placeholder: { type: String as PropType<TranslateResult>, default: "" },
  noResultLabel: { type: String, default: $t("No elements found. Consider changing the search query.") },
  noOptionsLabel: { type: String, default: $t("List is empty.") },
  maxSelectedLabel: { type: String },
};

export default defineComponent({
  name: "BaseDropdown",
  components: { BaseIconButton, ValidationProvider, Multiselect, BaseIcon, BaseAvatar, BaseSpinner },
  props: {
    ...defaultProps,
    ...selectProps,
  },
  setup(props, { slots, emit, listeners }) {
    const text = "text";
    const multiselect = ref();
    const isGroupOptions = computed(
      // eslint-disable-next-line no-prototype-builtins
      () => !!(props.options && props.options.length && props.options[0].hasOwnProperty("groupLabel"))
    );
    const selectedValue = computed(() => {
      if (isGroupOptions.value) return props.value;
      return (
        props.options &&
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        props.options.find((option: DropdownOptionStructure) => {
          return option.value === props.value;
        })
      );
    });

    const customListeners = computed(() => {
      const { input, ...restListeners } = listeners;
      return restListeners;
    });

    const hasValue = computed(() =>
      Array.isArray(selectedValue.value) ? selectedValue.value?.length > 0 : !!selectedValue.value
    );
    const hasLabel = computed(() => !!props.label || !!slots.label);
    const hasPlaceholder = computed(() => !!props.placeholder || !!slots.placeholder);
    const hasPrepend = computed(() => !!props.prependIcon || !!slots.prependIcon);

    const onInput = (newValue: DropdownOptionStructure) => {
      if (isGroupOptions.value) {
        emit("input", newValue);
      } else {
        newValue && emit("input", newValue.value);
      }
    };

    const onValidation = (...v: any[]) => {
      emit("validation", ...v);
    };

    return {
      text,
      multiselect,
      selectedValue,
      hasValue,
      hasLabel,
      hasPlaceholder,
      hasPrepend,
      customListeners,
      onValidation,
      onInput,
    };
  },
});
